// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.src-businessServices-services-bsMeasurementChart-MChartEntity-EditMCEntity-MChartTable-MChartTable-module__tableBox--BIKUm {
  flex: 1;
  min-width: 50%;
  overflow: hidden;
  display: flex;
  flex-direction: column;
}
.src-businessServices-services-bsMeasurementChart-MChartEntity-EditMCEntity-MChartTable-MChartTable-module__tableHeader--EyJMc {
  display: grid;
  overflow: hidden;
}
.src-businessServices-services-bsMeasurementChart-MChartEntity-EditMCEntity-MChartTable-MChartTable-module__tableBody--kOWl9 {
  flex: 1;
  overflow: auto;
}
.src-businessServices-services-bsMeasurementChart-MChartEntity-EditMCEntity-MChartTable-MChartTable-module__cellTop--bbBiL {
  border-top: thin solid #e1e3e6;
}
.src-businessServices-services-bsMeasurementChart-MChartEntity-EditMCEntity-MChartTable-MChartTable-module__cellLeft--9V52b {
  border-left: thin solid #e1e3e6;
}
.src-businessServices-services-bsMeasurementChart-MChartEntity-EditMCEntity-MChartTable-MChartTable-module__cell--Djbz_ {
  border-right: thin solid #e1e3e6;
  border-bottom: thin solid #e1e3e6;
  min-width: 60px;
}
.src-businessServices-services-bsMeasurementChart-MChartEntity-EditMCEntity-MChartTable-MChartTable-module__cellRow--pER9c {
  color: #343a41;
  font-size: 12px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
  overflow: hidden;
}
.src-businessServices-services-bsMeasurementChart-MChartEntity-EditMCEntity-MChartTable-MChartTable-module__baseSizeCell--IOKiP {
  background-color: #eff5ff;
}
.src-businessServices-services-bsMeasurementChart-MChartEntity-EditMCEntity-MChartTable-MChartTable-module__cellHd--N61A4 {
  color: #767c84;
  font-size: 12px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
}
.src-businessServices-services-bsMeasurementChart-MChartEntity-EditMCEntity-MChartTable-MChartTable-module__cellCentered--YiX3O {
  text-align: center;
  padding-top: 4px;
}
.src-businessServices-services-bsMeasurementChart-MChartEntity-EditMCEntity-MChartTable-MChartTable-module__pad--xpXMc {
  padding: 8px;
}
.src-businessServices-services-bsMeasurementChart-MChartEntity-EditMCEntity-MChartTable-MChartTable-module__fullCentered--ZSwMr {
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
.src-businessServices-services-bsMeasurementChart-MChartEntity-EditMCEntity-MChartTable-MChartTable-module__cell--Djbz_ .ant-input-number {
  background: none;
}
`, "",{"version":3,"sources":["webpack://./src/businessServices/services/bsMeasurementChart/MChartEntity/EditMCEntity/MChartTable/MChartTable.module.less"],"names":[],"mappings":"AAEA;EACE,OAAA;EACA,cAAA;EACA,gBAAA;EACA,aAAA;EACA,sBAAA;AADF;AAIA;EACE,aAAA;EACA,gBAAA;AAFF;AAIA;EACE,OAAA;EACA,cAAA;AAFF;AAKA;EACE,8BAAA;AAHF;AAKA;EACE,+BAAA;AAHF;AAMA;EACE,gCAAA;EACA,iCAAA;EACA,eAAA;AAJF;AAOA;EACE,cAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,gBAAA;AALF;AAOA;EACE,yBAAA;AALF;AAQA;EACE,cAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;AANF;AAQA;EACE,kBAAA;EACA,gBAAA;AANF;AAQA;EACE,YAAA;AANF;AASA;EACE,YAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,mBAAA;AAPF;AAWA;EACE,gBAAA;AATF","sourcesContent":["@border: thin solid #e1e3e6;\n\n.tableBox {\n  flex: 1;\n  min-width: 50%;\n  overflow: hidden;\n  display: flex;\n  flex-direction: column;\n}\n\n.tableHeader {\n  display: grid;\n  overflow: hidden;\n}\n.tableBody {\n  flex: 1;\n  overflow: auto;\n}\n\n.cellTop {\n  border-top: @border;\n}\n.cellLeft {\n  border-left: @border;\n}\n\n.cell {\n  border-right: @border;\n  border-bottom: @border;\n  min-width: 60px;\n}\n\n.cellRow {\n  color: #343a41;\n  font-size: 12px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: normal;\n  overflow: hidden;\n}\n.baseSizeCell {\n  background-color: #eff5ff;\n}\n\n.cellHd {\n  color: #767c84;\n  font-size: 12px;\n  font-style: normal;\n  font-weight: 700;\n  line-height: normal;\n}\n.cellCentered {\n  text-align: center;\n  padding-top: 4px;\n}\n.pad {\n  padding: 8px;\n}\n\n.fullCentered {\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n}\n\n// Иначе активный столбец подсвечивает тользо заголовок\n.cell :global(.ant-input-number) {\n  background: none;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"tableBox": `src-businessServices-services-bsMeasurementChart-MChartEntity-EditMCEntity-MChartTable-MChartTable-module__tableBox--BIKUm`,
	"tableHeader": `src-businessServices-services-bsMeasurementChart-MChartEntity-EditMCEntity-MChartTable-MChartTable-module__tableHeader--EyJMc`,
	"tableBody": `src-businessServices-services-bsMeasurementChart-MChartEntity-EditMCEntity-MChartTable-MChartTable-module__tableBody--kOWl9`,
	"cellTop": `src-businessServices-services-bsMeasurementChart-MChartEntity-EditMCEntity-MChartTable-MChartTable-module__cellTop--bbBiL`,
	"cellLeft": `src-businessServices-services-bsMeasurementChart-MChartEntity-EditMCEntity-MChartTable-MChartTable-module__cellLeft--9V52b`,
	"cell": `src-businessServices-services-bsMeasurementChart-MChartEntity-EditMCEntity-MChartTable-MChartTable-module__cell--Djbz_`,
	"cellRow": `src-businessServices-services-bsMeasurementChart-MChartEntity-EditMCEntity-MChartTable-MChartTable-module__cellRow--pER9c`,
	"baseSizeCell": `src-businessServices-services-bsMeasurementChart-MChartEntity-EditMCEntity-MChartTable-MChartTable-module__baseSizeCell--IOKiP`,
	"cellHd": `src-businessServices-services-bsMeasurementChart-MChartEntity-EditMCEntity-MChartTable-MChartTable-module__cellHd--N61A4`,
	"cellCentered": `src-businessServices-services-bsMeasurementChart-MChartEntity-EditMCEntity-MChartTable-MChartTable-module__cellCentered--YiX3O`,
	"pad": `src-businessServices-services-bsMeasurementChart-MChartEntity-EditMCEntity-MChartTable-MChartTable-module__pad--xpXMc`,
	"fullCentered": `src-businessServices-services-bsMeasurementChart-MChartEntity-EditMCEntity-MChartTable-MChartTable-module__fullCentered--ZSwMr`
};
export default ___CSS_LOADER_EXPORT___;
